import { combineReducers } from "redux";
import { auth } from "../app/auth/auth.reducer";
import { chats } from "app/chats/chats.reducer";
import { user } from "app/user/user.reducer";

const RootReducers = combineReducers({ auth , chats , user});


export default RootReducers;
